<ng-scrollbar visibility="hover">
  <div class="d-flex flex-column ps-4 pe-4 pt-4 pb-5">
    <h1>{{ 'mailings.title' | translate }}</h1>
    <br>
    <br>
    <div class="d-flex card-wrapper">
      <form [formGroup]="formGroup">
      <div class="d-flex flex-column">
        <h1>{{ 'mailings.headerRepresentatives' | translate }}</h1>
        <div class="d-flex flex-row gap-1">
          <app-input-field class="field-container" [label]="'mailings.emails'|translate" [control]="formGroup.controls.emailsRepresentatives"
                           style="flex-grow: 1; min-width: 0;">
            <input name="emailsRepresentatives" formControlName="emailsRepresentatives" placeholder="{{'mailings.loading' | translate}}" class="input" readonly style="width: 100%;">
          </app-input-field>
          <button class="blue-border" (click)="copyEmailsByCategory('representatives')" [disabled]="representativesButtonDisabled" style="margin-top: 24px; margin-bottom: 24px">
            <img src="assets/svg-icons/copy-button.svg" alt="copy icon" style="height: 15px; width: auto;">
            {{ 'mailings.buttonCopy' | translate }}
          </button>
          <button class="blue-border" (click)="sendEmailByCategory('representatives')" [disabled]="representativesButtonDisabled" style="margin-top: 24px; margin-bottom: 24px">
            <img src="assets/svg-icons/profile-user/send.svg" alt="send icon" style="height: 15px; width: auto;">
            {{ 'mailings.buttonSend' | translate }}
          </button>
        </div>
      </div>

      <hr/>

      <div class="d-flex flex-column">
        <h1>{{ 'mailings.headerBoardMembers' | translate }}</h1>
        <div class="d-flex flex-row gap-1">
          <app-input-field class="field-container" [label]="'mailings.emails'|translate" [control]="formGroup.controls.emailsBoardMembers"
                           style="flex-grow: 1; min-width: 0;">
            <input name="emailsBoardMembers" formControlName="emailsBoardMembers" placeholder="{{'mailings.loading' | translate}}" class="input" readonly style="width: 100%;">
          </app-input-field>
          <button class="blue-border" (click)="copyEmailsByCategory('boardMembers')" [disabled]="boardMembersButtonDisabled" style="margin-top: 24px; margin-bottom: 24px">
            <img src="assets/svg-icons/copy-button.svg" alt="copy icon" style="height: 15px; width: auto;">
            {{ 'mailings.buttonCopy' | translate }}
          </button>
          <button class="blue-border" (click)="sendEmailByCategory('boardMembers')" [disabled]="boardMembersButtonDisabled" style="margin-top: 24px; margin-bottom: 24px">
            <img src="assets/svg-icons/profile-user/send.svg" alt="send icon" style="height: 15px; width: auto;">
            {{ 'mailings.buttonSend' | translate }}
          </button>
        </div>
      </div>

      <hr/>

      <div class="d-flex flex-column">
        <h1>{{ 'mailings.headerEarlyBirds' | translate }}</h1>
        <div class="d-flex flex-row gap-1">
          <app-input-field class="field-container" [label]="'mailings.emails'|translate" [control]="formGroup.controls.emailsEarlyBirds"
                           style="flex-grow: 1; min-width: 0;">
            <input name="emailsEarlyBirds" formControlName="emailsEarlyBirds" placeholder="{{'mailings.loading' | translate}}" class="input" readonly style="width: 100%;">
          </app-input-field>
          <button class="blue-border" (click)="copyEmailsByCategory('earlyBirds')" [disabled]="earlyBirdsButtonDisabled" style="margin-top: 24px; margin-bottom: 24px">
            <img src="assets/svg-icons/copy-button.svg" alt="copy icon" style="height: 15px; width: auto;">
            {{ 'mailings.buttonCopy' | translate }}
          </button>
          <button class="blue-border" (click)="sendEmailByCategory('earlyBirds')" [disabled]="earlyBirdsButtonDisabled" style="margin-top: 24px; margin-bottom: 24px">
            <img src="assets/svg-icons/profile-user/send.svg" alt="send icon" style="height: 15px; width: auto;">
            {{ 'mailings.buttonSend' | translate }}
          </button>
        </div>
      </div>

      <hr/>

      <div class="d-flex flex-column">
        <h1>{{ 'mailings.headerUsers' | translate }}</h1>
        <div class="d-flex flex-row gap-1">
          <app-input-field class="field-container" [label]="'mailings.emails'|translate" [control]="formGroup.controls.emailsExchangeMembers"
                           style="flex-grow: 1; min-width: 0;">
            <input name="emailsExchangeMembers" formControlName="emailsExchangeMembers" placeholder="{{'mailings.loading' | translate}}" class="input" readonly style="width: 100%;">
          </app-input-field>
          <button class="blue-border" (click)="copyEmailsByCategory('exchangeMembers')" [disabled]="exchangeMembersButtonDisabled" style="margin-top: 24px; margin-bottom: 24px">
            <img src="assets/svg-icons/copy-button.svg" alt="copy icon" style="height: 15px; width: auto;">
            {{ 'mailings.buttonCopy' | translate }}
          </button>
          <button class="blue-border" (click)="sendEmailByCategory('exchangeMembers')" [disabled]="exchangeMembersButtonDisabled" style="margin-top: 24px; margin-bottom: 24px">
            <img src="assets/svg-icons/profile-user/send.svg" alt="send icon" style="height: 15px; width: auto;">
            {{ 'mailings.buttonSend' | translate }}
          </button>
        </div>
      </div>

      <hr/>
      </form>
    </div>
  </div>
</ng-scrollbar>
